import img1 from "../images/icon-snappy-process.svg";
import img2 from "../images/icon-affordable-prices.svg";
import img3 from "../images/icon-people-first.svg";
import React from "react";

const Howwework = () => {
  return (
    <>
      <div className="workcontainer">
        <div className="workheading">
          <hr />
          We’re different
        </div>
        <div className="processcontainer">
          <div className="process1">
            <img src={img1} className="snappyphoto" alt="snappy process" />
            <div> Snappy Process</div>
            <p>
              {" "}
              Our application process can be completed in minutes, not hours.
              Don’t get stuck filling in tedious forms.
            </p>
          </div>
          <div className="process2">
            <img src={img2} alt="affordable prices" />
            <div> Affordable Prices</div>
            <p>
              {" "}
              We don’t want you worrying about high monthly costs. Our prices
              may be low, but we still offer the best coverage possible.
            </p>
          </div>
          <div className="process3">
            <img src={img3} alt="people first" />
            <div> People First</div>
            <p>
              Our plans aren’t full of conditions and clauses to prevent
              payouts. We make sure you’re covered when you need it.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Howwework;
